// SearchBar.jsx
import React, { useEffect, useState } from "react";

const SearchBar = ({ className, onSearch, value = "" }) => {
  const [query, setQuery] = useState(value);

  // синхронизация с внешним значением
  useEffect(() => {
    setQuery(value ?? "");
  }, [value]);

  const handleChange = (e) => setQuery(e.target.value);
  const handleSearchClick = () => onSearch(query);
  const handleKeyDown = (e) => e.key === "Enter" && handleSearchClick();

  return (
    <div className={`header__search ${className || ""}`}>
      <input
        type="text"
        value={query}
        placeholder="Поиск по названию или артикулу"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      <button className="header__search-btn" onClick={handleSearchClick}>🔍</button>
    </div>
  );
};

export default SearchBar;
